export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_08_blank.fcb63b70.png";